var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chart',{staticClass:"mt--5",attrs:{"option":_vm.option,"autoresize":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }